package com.shadowings.gero.presentation.component.avatars

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.BlendMode
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.presentation.screen.characters.backgroundOptions
import com.shadowings.gero.presentation.util.DeviceClass
import com.shadowings.gero.presentation.util.rememberDeviceInfo
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun BuildAvatar(
    withBackground: Boolean,
    bgColorIndex: Int,
    pairs: List<Pair<DrawableResource, Color>>,
    expression: List<Pair<DrawableResource, Color>>,
    modifier: Modifier,
    face: Faces
) {
    if (withBackground) {
        val deviceInfo = rememberDeviceInfo()
        val avatarSize = when (deviceInfo.deviceClass) {
            DeviceClass.PHONE_SMALL -> 64.dp
            DeviceClass.PHONE_MEDIUM -> 80.dp
            DeviceClass.PHONE_LARGE -> 100.dp
            DeviceClass.TABLET_MEDIUM -> 120.dp
            DeviceClass.TABLET_LARGE -> 150.dp
            DeviceClass.WEB_FULL -> 150.dp
        }
        Box(
            Modifier.background(
                color = backgroundOptions[bgColorIndex],
                shape = RoundedCornerShape(6.dp)
            )
        ) {
            Box(
                Modifier
                    .height(avatarSize)
                    .align(Alignment.BottomCenter)
            ) {
                // Manteniamo 11 slot stabili: così quando cambia una risorsa, sostituiamo quello slot
                // senza creare overlap o riordini strani.
                (pairs + expression).forEachIndexed { index, pair ->
                    key(index) {
                        Image(
                            modifier = Modifier.fillMaxHeight().align(Alignment.BottomCenter),
                            painter = painterResource(pair.first),
                            contentDescription = null,
                            colorFilter = ColorFilter.tint(
                                color = if (face == Faces.AllBlack) Color.Black else pair.second,
                                blendMode = BlendMode.SrcIn
                            ),
                            contentScale = ContentScale.FillHeight
                        )
                    }
                }
            }
        }
    } else {
        Box(modifier) {
            // Manteniamo 11 slot stabili: così quando cambia una risorsa, sostituiamo quello slot
            // senza creare overlap o riordini strani.
            (pairs + expression).forEachIndexed { index, pair ->
                key(index) {
                    Image(
                        modifier = Modifier.fillMaxHeight().align(Alignment.BottomCenter),
                        painter = painterResource(pair.first),
                        contentDescription = null,
                        colorFilter = ColorFilter.tint(
                            color = if (face == Faces.AllBlack) Color.Black else pair.second,
                            blendMode = BlendMode.SrcIn
                        ),
                        contentScale = ContentScale.FillHeight
                    )
                }
            }
        }
    }
}